// extracted by css-extract-rspack-plugin
export default {"container":"ssVFd35XNOUoJuj0","trigger":"CrePaP7l9IIBZL4_","menu":"TqiroOrrFYOQWzG2","label":"l7Q4RcUy0M9vIRZN"};